import React from 'react'
import { useMemo } from 'sb-hooks'

import { Row, Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import messages from './mesages'


export type SkinAndAgeTypesProps = {
  ageCategory?: string
  skinType?: string
}


const SkinAndAgeTypes: React.FunctionComponent<SkinAndAgeTypesProps> = ({ ageCategory, skinType }) => {
  const typesItems = useMemo(() => {
    const result = []

    if (ageCategory) {
      result.push({
        title: messages.ageCategory,
        value: ageCategory,
      })
    }
    if (skinType) {
      result.push({
        title: messages.skinType,
        value: skinType,
      })
    }

    return result
  }, [ ageCategory, skinType ])

  return (
    <Row justify="start">
      {
        typesItems.map(({ title, value }, index) => (
          <Box key={index} pl={Boolean(index) ? '12' : null}>
            <Row>
              <Text
                message={title}
                color="gray-50"
                size="14-16"
              />
              <Box pl={4}>
                <Text
                  message={value}
                  color="black"
                  size="14-16"
                />
              </Box>
            </Row>
          </Box>
        ))
      }
    </Row>
  )
}


export default SkinAndAgeTypes
